export const exType = {
  ex: 'ex',
  contract: 'contract',
  second: 'second'
}

export const orderType = {
  limit: 1, // 限价
  market: 2 // 市价
}

export const orderSide = {
  sell: 1,
  buy: 2
}

export const orderStatus = {
  
  entrust: 0,
  complete: 1,
  cancel: 2,
}

export const contractType = {
  
  entrust: 0,
  open: 1,
  flat: 2,
  cancel: 3,
}